import { render, staticRenderFns } from "./MonitorControlls.vue?vue&type=template&id=66828340"
import script from "./MonitorControlls.vue?vue&type=script&lang=js"
export * from "./MonitorControlls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports